import * as Constants from '@squaredup/constants';
import { RollUpPluginConfigId, RollUpPluginDisplayName, RollUpPluginId } from '@squaredup/ids';
import { PluginSourceConfig } from 'services/SourceConfigService';

export const RollUpPluginConfig: PluginSourceConfig = {
    id: RollUpPluginConfigId.value,
    displayName: RollUpPluginDisplayName,
    plugin: {
        name: RollUpPluginDisplayName,
        displayName: RollUpPluginDisplayName,
        pluginId: RollUpPluginId.value
    },
    source: 'PLUGIN',
    description: '',
    importStatus: undefined,
    type: 'config',
    subType: 'source.plugin',
    tenant: `ten-${Constants.GlobalTenantId}` as `ten-${string}`
};